import { ReactElement } from 'react'
import { Textarea } from '@raskrask-dk/rr-components'
import { useTranslation } from 'react-i18next'
import CompanyCardPage from '../../companycard'
import { DescriptionTemplateProps } from './props'

const DescriptionTemplate = ({
    choosenText,
    currentStep,
    dataCy,
    helpers,
    onChangeDescription,
}: DescriptionTemplateProps): ReactElement => {
    const { t } = useTranslation()

    return (
        <CompanyCardPage
            choosenText={choosenText ? [choosenText] : undefined}
            dataCy={dataCy}
            open={currentStep === 6}
            setOpen={() => helpers.setStep(currentStep === 6 ? 7 : 6)}
            showNextButton={false}
            title={t('companylead.comments.header')}
        >
            <Textarea
                data-cy="leadDescription"
                minRows={3}
                onChange={(e) => onChangeDescription(e)}
                placeholder={t('companylead.comments.placeholder')}
                maxRows={6}
                value={choosenText}
            />
        </CompanyCardPage>
    )
}

export default DescriptionTemplate
